export const landLordTypes = {
    GET_LANDLORD_LIST: 'GET_LANDLORD',
    GET_LANDLORD_LIST_ERROR: 'GET_LANDLORD_LIST_ERROR'
}